import * as React from "react"
import { useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/products/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function ProductList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Product</h5>
      </div>

      <CrudProvider>
        <ProductTable />
      </CrudProvider>
    </>
  )
}

function ProductTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Product"
        columns={columns}
        apiPath="product"
        onImport={true}
        onExport={true}
        onEditImport={true}
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}
